<template>
    <div>
        <div class="topbar">
            <div class="topbar__inner">
                <div class="topbar__key" action="">
                    <header class="topbar__key__header">
                        Showing
                        <select v-if="totalRowsCount >= 25" class="topbar__key__select" v-model="pageLength">
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="200">200</option>
                        </select>
                        <template v-else>{{totalRowsCount}}</template>

                        of {{stringHelper.formatNumber(totalRowsCount)}}
                    </header>
                    
                    <div class="d-flex">
                        <Autocompleter
                            ref="keywordAutocompleter"
                            v-model="currentKeyword"
                            placeHolder="Add a Keyword"
                            inputClass="form-search-primary"
                            updateURL = "/search/suggest"
                            :clearOnSubmit = true
                            v-on:submitted="keywordAutocompleteSubmitted"
                        >
                        </Autocompleter>
                        
                        <div class="topbar__hint">
                            <b-dropdown id="dropdown-1" text="" class="topbar__hint icons-list dropdown-small">
                                <b-dropdown-item class="icons-list__quote" @click="applySearchOperator('exact-match', currentKeyword);">
                                    Use quotes for an exact match
                                </b-dropdown-item>
    
                                <b-dropdown-item class="icons-list__startup" @click="applySearchOperator('name', currentKeyword);">
                                    Type “Name:” to search for a<template v-if="searchType == 'ecosystems'">n</template><br/> <template v-if="searchType == 'ecosystems'">ecosystem’s</template><template v-else>startup’s</template> name
                                </b-dropdown-item>
    
                                <b-dropdown-item v-if="false" class="icons-list__lightbulb">
                                    Learn how to use search
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>

                    <footer class="topbar__key__footer">
                        <span class="topbar__key__label">Filtered by:</span>

                        <equation-bar
                            :query="query"
                            v-on:rule-deleted="deleteRule"
                            v-on:delete-all-rules="deleteAllRules"
                            v-on:invert-rule="invertRule"
                            v-on:edit-group="editGroup"
                            v-on:update-search="getList"
                            v-on:toggle-condition="toggleCondition"
                        >
                        </equation-bar>
                        <a v-if="query.rules.length" @click="deleteAllRules" class="key__filter__clear">Clear All</a>

                        <ul class="topbar__side actions-list">
                            <!--li>
                                <select class="topbar__key__select topbar__key__select--small">
                                    <option>This view</option>
                                    <option>View</option>
                                </select>
                            </li-->
                            <li><a class="topbar__side__save" v-if="canUpdateSavedSearch" @click="updateSavedSearch">Update Saved Search</a></li>
                            <li><a class="topbar__side__save" v-if="query.rules.length" @click="openSaveSearch">Save Search</a></li>

                            <li class="actions-list__edit"><a @click="openManageColumns">Edit Columns</a></li>
                            <li v-if="selectedRows.length">
                                <div>
                                    <b-dropdown id="dropdown-1" text="Actions" class="topbar__side__actions">
                                        <b-dropdown-item class="action" @click="openAddTags" v-if="searchType == 'startups'">
                                            <font-awesome-icon :icon="['fa', 'tags']" />
                                            Add Tags
                                        </b-dropdown-item>

                                        <b-dropdown-item class="action" @click="openRemoveTags" v-if="searchType == 'startups'">
                                            <font-awesome-icon :icon="['fa', 'tags']" />
                                            Remove Tags
                                        </b-dropdown-item>

                                        <b-dropdown-item class="action" @click="openAddToTrackers" v-if="searchType == 'startups'">
                                            <font-awesome-icon :icon="['fa', 'plus']" />
                                            Add To Trackers
                                        </b-dropdown-item>

                                        <b-dropdown-item class="action" @click="exportCSV">
                                            <font-awesome-icon :icon="['fa', 'file-csv']" />
                                            Export CSV
                                        </b-dropdown-item>
                                        <b-dropdown-item v-if="false" class="action"  v-b-modal.modal-ExportContacts>
                                            <font-awesome-icon :icon="['fa', 'address-book']" />
                                            Export Contacts
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </div>
                            </li>
                        </ul>
                    </footer>
                </div>
            </div>
        </div>

        <div>
            <main class="main main--scrolled" :class="{'main--collapsed': leftCollapsed}">
                <aside class="aside">
                    <div class="aside__inner">
                        <header class="aside__header">
                            Filters

                            <a class="aside__collapse" @click="leftCollapsed = !leftCollapsed"></a>
                        </header>

                        <ul class="filters__list">
                            <li v-if="searchType == 'startups'">
                                <a class="filters__list__title" v-b-toggle.filter-tags>
                                    Tags
                                </a>

                                <b-collapse class="filters__list__content" id="filter-tags">
                                    <multiselect
                                        v-model="filters.tags"
                                        :multiple="true"
                                        placeholder="Select tags"
                                        :options="filtersOptions.tags"
                                        select-label=""
                                        deselect-label=""
                                        label="name"
                                        track-by="name"
                                        class="multiselect-mid pl-2"
                                    >
                                    </multiselect>
                                </b-collapse>
                            </li>

                            <li>
                                <a class="filters__list__title" v-b-toggle.filter-category>
                                    Category
                                </a>

                                <b-collapse class="filters__list__content" id="filter-category">
                                    <multiselect
                                        v-model="filters.categories"
                                        :multiple="true"
                                        placeholder="Select categories"
                                        :options="filtersOptions.categories"
                                        select-label=""
                                        deselect-label=""
                                        label="name"
                                        track-by="name"
                                        class="multiselect-mid pl-2"
                                    >
                                    </multiselect>
                                </b-collapse>
                            </li>

                            <li>
                                <a class="filters__list__title" v-b-toggle.filter-location>
                                    Location
                                </a>

                                <b-collapse class="filters__list__content" id="filter-location">
                                    <multiselect
                                        v-model="filters.locations"
                                        :multiple="true"
                                        placeholder="Select locations"
                                        :options="filtersOptions.locations"
                                        select-label=""
                                        deselect-label=""
                                        label="name"
                                        track-by="name"
                                        @search-change="updateStartupLocationsList"
                                        class="multiselect-mid pl-2"
                                    >
                                    </multiselect>
                                </b-collapse>
                            </li>

                            <li v-if="searchType == 'startups'">
                                <a class="filters__list__title" v-b-toggle.filter-fundingSeries @click="getInvestorsList">
                                    Funding
                                </a>

                                <b-collapse class="filters__list__content" id="filter-fundingSeries">
                                    <ul class="filters__list__choose">
                                        <li class="input-checkbox mr-1" v-for="option in filtersOptions['fundingSeries']" :key="option.id">
                                            <input v-model="filters['fundingSeries']" :value="option" :id="'filter-fundingSeries-' + option.value" type="checkbox">
                                            <label :for="'filter-fundingSeries-' + option.value">{{ option.name }}</label>
                                        </li>
                                    </ul>

                                    <h6 class="heading6 heading6--secondary">Last funding date:</h6>

                                    <a class="calendar-link" style="margin-bottom: 10px" v-if="!showCalendar.lastFundingDate" @click="showCalendar.lastFundingDate = true">Select Date</a>
                                    <date-picker style="margin-bottom: 10px" v-if="showCalendar.lastFundingDate" v-model="filters.lastFundingDate" type="year" range :default-value="[new Date(Date.now()-1000*60*60*24*365*20), new Date(Date.now()-1000*60*60*24*365*10)]"></date-picker>

                                    <multiselect
                                        v-model="filters.fundingRange"
                                        placeholder="Select funding range"
                                        :multiple="true"
                                        :options="filtersOptions.fundingRange"
                                        select-label=""
                                        deselect-label=""
                                        label="name"
                                        track-by="name"
                                        class="multiselect-mid pl-2"
                                    >
                                    </multiselect>

                                    <h6 class="heading6 heading6--secondary mt-3">Investors:</h6>
                                    <multiselect
                                        v-model="filters.investors"
                                        :multiple="true"
                                        placeholder="Select investors"
                                        :options="filtersOptions.investors"
                                        select-label=""
                                        deselect-label=""
                                        label="name"
                                        track-by="name"
                                        @search-change="getInvestorsList"
                                        class="multiselect-mid pl-2"
                                    >
                                    </multiselect>
                                </b-collapse>
                            </li>

                            <li v-if="searchType == 'startups'">
                                <a class="filters__list__title" v-b-toggle.filter-ecosystem>
                                    Ecosystems
                                </a>

                                <b-collapse class="filters__list__content" id="filter-ecosystem">
                                    <multiselect
                                        v-model="filters.ecosystems"
                                        :multiple="true"
                                        placeholder="Select ecosystems"
                                        :options="filtersOptions.ecosystems"
                                        select-label=""
                                        deselect-label=""
                                        label="name"
                                        track-by="name"
                                        @search-change="updateEcosystemsList"
                                        class="multiselect-mid pl-2"
                                    >
                                    </multiselect>
                                </b-collapse>
                            </li>

                            <li v-if="searchType == 'startups'">
                                <a class="filters__list__title" v-b-toggle.filter-trackers>
                                    Trackers
                                </a>

                                <b-collapse class="filters__list__content" id="filter-trackers">
                                    <multiselect
                                        v-model="filters.trackers"
                                        :multiple="true"
                                        placeholder="Select trackers"
                                        :options="filtersOptions.trackers"
                                        select-label=""
                                        deselect-label=""
                                        label="name"
                                        track-by="name"
                                        class="multiselect-mid pl-2"
                                    >
                                    </multiselect>
                                </b-collapse>
                            </li>

                            <li>
                                <a class="filters__list__title" v-b-toggle.filter-saved-searches>
                                    Saved Searches
                                </a>

                                <b-collapse class="filters__list__content" id="filter-saved-searches">
                                    <multiselect
                                        v-model="savedSearch"
                                        :options="savedSearches"
                                        placeholder="Select saved search"
                                        select-label=""
                                        deselect-label=""
                                        group-values="items"
                                        group-label="group"
                                        :group-select="false"
                                        label="name"
                                        track-by="name"
                                        class="multiselect-mid pl-2"
                                    >
                                    </multiselect>

                                    <a v-if="savedSearches.length" @click="openManageSavedSearches" class="filters__list__link d-block text-right">Manage Saved Searches</a>
                                </b-collapse>
                            </li>

                            <li>
                                <a class="filters__list__title" v-b-toggle.filter-more>
                                    More
                                </a>

                                <b-collapse class="filters__list__content" id="filter-more">
                                    <template v-if="searchType == 'startups'">
                                        <a class="filters__list__link filters__custom" @click="openCustomDataFilter">Filter By Your Custom Fields</a>

                                        <multiselect
                                            v-model="filters.revenueRange"
                                            placeholder="Select revenue range"
                                            :multiple="true"
                                            :options="filtersOptions.revenueRange"
                                            select-label=""
                                            deselect-label=""
                                            label="name"
                                            track-by="name"
                                            class="multiselect-mid pl-2"
                                        >
                                        </multiselect>
                                        <br>
                                    </template>

                                    <multiselect
                                        v-model="filters.employeeCount"
                                        placeholder="Select employee count"
                                        :multiple="true"
                                        :options="filtersOptions.employeeCount"
                                        select-label=""
                                        deselect-label=""
                                        label="name"
                                        track-by="name"
                                        class="multiselect-mid pl-2"
                                    >
                                    </multiselect>

                                    <br/>

                                    <h6 class="heading6 heading6--secondary">Date founded:</h6>

                                    <a class="calendar-link" v-if="!showCalendar.foundedYear" @click="showCalendar.foundedYear = true">Select Date</a>
                                    <date-picker v-if="showCalendar.foundedYear" v-model="filters.foundedYear" type="year" range :default-value="[new Date(Date.now()-1000*60*60*24*365*20), new Date(Date.now()-1000*60*60*24*365*10)]"></date-picker>

                                    <template v-if="searchType == 'startups' && $store.state.user.settings.search_big_companies">
                                        <div class="input-checkbox mt-3">
                                            <input type="checkbox" id="include-input" v-model="includeHidden">
                                            <label for="include-input">Include Hidden Companies</label>
                                        </div>
                                    </template>
                                </b-collapse>
                            </li>
                        </ul>
                    </div>
                </aside>

                <div class="content">
                    <div class="content__inner" style="position: relative">
                        <pulse-loader :loading="showSpinner" :color="constants.spinnerColor"></pulse-loader>

                        <Grid
                              v-if="startups.length"
                              :columns="columns"
                              :has-checkbox-column="true"
                              :addCellData="addCellData"
                              :data="startups"
                              :page-length="parseInt(pageLength)"
                              :total-rows-count="totalRowsCount"
                              :sort="sort"
                              :currentPage="currentPage"
                              v-on:changePage="changePage"
                              v-on:changeSort="changeSort"
                              v-on:manageColumns="openManageColumns"
                              v-on:selectedRowsChanged="changeSelectedRows"
                              v-on:selectAllResults="selectAllResults"
                              v-on:action="gridAction"
                        >
                        </Grid>

                        <div v-if="firstLoaded && !startups.length" class="card card--bordered card--empty">
                            <header class="card__header">
                                <h4 class="heading4">No <template v-if="searchType == 'ecosystems'">ecosystems</template><template v-else>startups</template> found</h4>
                            </header>
                            <p>Try removing or changing some of your keywords</p>
                        </div>
                    </div>
                </div>
            </main>
        </div>

        <ManageColumns
            ref="manageColumns"
            :tableType="tableColumnsType"
            v-on:changeColumns="getColumns"
        >
        </ManageColumns>

        <CustomDataFilter
            :filters-list="customFieldsList"
            :for-search="true"
            ref="customDataFilter"
            v-on:updateCustomDataFilter="updateCustomDataFilter"
        >
        </CustomDataFilter>

        <SaveSearch
            ref="saveSearch"
            :searchType="searchType"
            :rules="query.rules"
            :savedSearchesList="savedSearches"
            v-on:saved-search-changed="savedSearchChanged"
        >
        </SaveSearch>

        <AddTags
            ref="addTags"
            :tags-list="tagsList"
            v-on:addTags="addTags"
        >
        </AddTags>

        <RemoveTags
            ref="removeTags"
            :tags-list="tagsList"
            v-on:removeTags="removeTags"
        >
        </RemoveTags>

        <AddToTrackers
            ref="addToTrackers"
            :trackers-list="trackersList"
            v-on:trackersSelected="addToTrackers"
        >
        </AddToTrackers>

        <b-modal id="modal-ExportContacts" title="Export Contacts" size="md">

            <p>Enter the titles of the contacts you want to export</p>
            <input type="text" class="form-control form-control--mid mb-3" placeholder="Title"/>

            <ul class="rows-list">
                <li>
                    <h5 class="heading5 heading5--secondary">Brand Manager</h5>
                    <a href="#" class="link-remove ml-auto">Remove</a>
                </li>
                <li>
                    <h5 class="heading5 heading5--secondary">Brand Manager</h5>
                    <a href="#" class="link-remove ml-auto">Remove</a>
                </li>
            </ul>

            <template #modal-footer>
                <b-button variant="primary" size="lg" @click="add">Export</b-button>
            </template>
        </b-modal>

        <GroupWords
            :rule="currentRule"
            ref="manageGroupWords"
            :allRelatedWords="relatedWords"
            v-on:save-group-words="saveGroupWords"
        >
        </GroupWords>

        <edit-tracker
            ref="editTracker"
            v-on:trackerSaved="trackerSaved"
        >
        </edit-tracker>

    </div>
</template>


<script>
import multiselect from 'vue-multiselect'
import Grid from '@/components/Grid'
import Autocompleter from '@/components/Autocompleter'
import EquationBar from '@/components/search/EquationBar.vue'
import equation from '@/components/search/equation'
import filterOptions from '@/components/search/filter-options'
import grid from '@/mixins/grid'
import scroll from '@/mixins/scroll'
import tags from '@/services/tags.service'
import trackers from '@/services/trackers.service'
import trackersStartups from '@/services/trackers-startups.service'
import exports from '@/services/exports.service'
import categories from '@/services/categories.service'
import locations from '@/services/locations.service'
import savedSearches from '@/services/saved-searches.service'
import ecosystems from '@/services/ecosystems.service'
import investors from '@/services/investors.service'

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import ManageColumns from '@/components/manage/ManageColumns.vue';
import CustomDataFilter from '@/components/manage/CustomDataFilter.vue';
import SaveSearch from '@/components/search/SaveSearch.vue';
import AddTags from '@/components/manage/AddTags.vue';
import RemoveTags from "@/components/manage/RemoveTags";
import AddToTrackers from '@/components/manage/SelectTrackers.vue';
import date from "@/helpers/date";
import axios from "axios";
import GroupWords from "@/components/search/GroupWords";
import editTracker from "@/components/trackers/EditTracker";
import user from "@/services/user.service";
import PulseLoader from "vue-spinner/src/MoonLoader";
import customFields from "@/services/custom-fields.service";

export default {
    props: {
        searchType: String,
    },

    components: {
        Grid,
        EquationBar,
        multiselect,
        DatePicker,
        ManageColumns,
        CustomDataFilter,
        SaveSearch,
        AddTags,
        RemoveTags,
        AddToTrackers,
        Autocompleter,
        GroupWords,
        editTracker,
        PulseLoader,
    },

    mixins: [equation, filterOptions, grid, scroll],

    data() {
        return {
            startups: [],
            canLoadList: true,
            showSpinner: false,
            firstLoaded: false,

            filters: {
                'fundingSeries': [],
                'fundingRange': [],
                'revenueRange': [],
                'employeeCount': [],
                'lastFundingDate': null,
                'foundedYear': null,
                'tags': [],
                'categories': [],
                'locations': [],
                'ecosystems': [],
                'trackers': [],
                'investors': [],
            },

            includeHidden: false,
            tagsList: [],
            trackersList: [],

            savedSearch: {},
            savedSearches: [],
            canUpdateSavedSearch: false,
            savedSearchApplied: false,
            customFieldsList: {},

            topStartupLocations: [],
            topEcosystems: [],

            leftCollapsed: false,
            currentKeyword: "",

            currentRule: {
                id: 0,
                value: "",
                groupWords: {},
                matchCount: {},
            },

            startupDetails: Array,
            notWatchFilters: false,

            showCalendar: {
                'lastFundingDate': true,
                'foundedYear': false,
            },

            addCellData: {
                companyType: this.searchType,
                trackersList: [],
                fromSearch: true,
            },

            relatedWords : {},
            initSavedSearch: 0,

            addStartupToTracker: null,
            notWatchQuery: false,
        }
    },

    computed: {
        tableColumnsType() {
            if (this.searchType == 'ecosystems') {
                return 'search-ecosystems'
            }
            else {
                return 'search-startups'
            }
        }
    },

    mounted() {
        this.$store.watch(state => {
            if (state.needUpdateTrackers) {
                this.getTrackersList()
            }

            if (state.user.company_id == this.constants.companyPfizer && state.user.settings.search_big_companies) {
                this.includeHidden = true
            }

            if (state.needUpdateStartups) {
                this.getList()
            }

            if (state.needUpdateUsers) {
                this.getList()
            }
        })

        this.getColumns()
        this.getTagsList()
        this.getTrackersList()
        this.getCategoriesList()
        this.getTopStartupLocationsList()
        this.getSavedSearches()
        this.getTopEcosystemsList()

        for (let name in this.filters) {
            this.$watch('filters.' + name, function () {
                if (!this.notWatchFilters) {
                    this.updateFilterRule(name)
                }
            }, {deep:true})
        }

        let keywords = this.$route.query.keywords

        if (typeof keywords !== 'undefined') {
            if (!Array.isArray(keywords)) {
                keywords = [keywords]
            }

            keywords.forEach(word => {
                let keyWord = this.stringHelper.sanitizeUrl(word);

                var rule =
                    {
                        "label"      : "Keyword",
                        "name"       : "keyword",
                        "value"      : keyWord,
                        "valueAlias" : keyWord,
                        "negative"   : false,
                        "groupWords"   : [],
                        "matchCount" : 1,
                    }

                this.prependRule(rule);
            })
        }

        let savedSearchId = this.$route.query.query
        let tag = this.$route.query.tag

        if (savedSearchId !== undefined) {
            this.canLoadList = false
            this.initSavedSearch = savedSearchId
        }

        if (tag !== undefined) {
            this.canLoadList = false
        }

        customFields.getFieldsNotStatic("company_diligence").then(response => {
            this.customFieldsList = response.data
        });
    },

    watch: {
        savedSearch() {
            this.savedSearchApplied = false

            if (this.savedSearch !== null) {
                this.clearFilters()
                this.applySavedSearch()
            }
            else {
                this.canUpdateSavedSearch = false
            }
        },

        query: {
            deep: true,
            handler() {

                if (!this.notWatchQuery) {
                    this.notWatchQuery = true
                    this.normalizeQuery()

                    this.$nextTick(() => {
                        this.notWatchQuery = false
                        this.getList()
                    })
                }

                if (this.savedSearchApplied) {
                    this.canUpdateSavedSearch = true;
                }
            }
        },

        includeHidden() {
            this.getList()
        },
    },

    methods: {
        getList() {
            if (this.canLoadList) {
                this.showSpinner = true
                let columns = this.arrayHelper.arrayColumn(this.columns, 'name')
                let sort = this.sort
                let query = this.query
                let params = {
                    includeHidden: this.includeHidden
                }
                let currentPage = this.currentPage
                let pageLength = this.pageLength
                let searchType = this.searchType

                axios.post("search/get-list", {searchType, columns, sort, query, currentPage, pageLength, params})
                    .then(response => {
                        console.log(response.data.query)
                        this.startups = response.data.data
                        this.totalRowsCount = parseInt(response.data.total_count)
                        this.currentPage = response.data.current_page
                        this.showSpinner = false
                        this.firstLoaded = true
                    })
            }
        },

        getTagsList() {
            tags.getListForSearch().then(response => {
                this.filtersOptions['tags'] = response.data

                let tag = this.$route.query.tag
                if (typeof tag !== 'undefined') {
                    let tagIndex = this.arrayHelper.findIndexByColumnValue(this.filtersOptions['tags'], 'name', tag)

                    this.canLoadList = true;
                    if (tagIndex >= 0) {
                        this.filters.tags.push(this.filtersOptions['tags'][tagIndex])
                    }
                    else {
                        if (this.columns.length) {
                            this.getList()
                        }
                    }
                }
            })

            tags.getList().then(response => {
                this.tagsList = response.data
            })
        },

        getTrackersList() {
            trackers.getList().then(response => {
                this.filtersOptions['trackers'] = response.data
            })

            trackers.getListForStartupAdd().then(response => {
                this.trackersList = response.data
                this.addCellData.trackersList = response.data
            })
        },

        getCategoriesList() {
            categories.getListForSearch().then(response => {
                this.filtersOptions['categories'] = response.data
            })
        },

        getInvestorsList(search) {
            investors.getListForSearch(search).then(response => {
                this.filtersOptions['investors'] = response.data
            })
        },

        getTopEcosystemsList() {
            ecosystems.getTopListForSearch().then(response => {
                this.filtersOptions['ecosystems'] = response.data
                this.topEcosystems = response.data
            })
        },

        updateEcosystemsList(query) {
            if (query.length) {
                ecosystems.getListForSearch(query).then(response => {
                    this.filtersOptions['ecosystems'] = response.data
                })
            }
            else {
                this.filtersOptions['ecosystems'] = this.topEcosystems
            }
        },

        getTopStartupLocationsList() {
            locations.getTopStartupsLocations().then(response => {
                this.filtersOptions['locations'] = response.data
                this.topStartupLocations = response.data
            })
        },

        updateStartupLocationsList(query) {
            if (query.length) {
                locations.getFilteredStartupsLocations(query).then(response => {
                    this.filtersOptions['locations'] = response.data
                })
            }
            else {
                this.filtersOptions['locations'] = this.topStartupLocations
            }
        },

        getSavedSearches() {
            savedSearches.getList(this.searchType).then(response => {
                this.savedSearches = response.data

                if (this.savedSearch && this.arrayHelper.findIndexByColumnValueInGroup(this.savedSearches, 'items', 'id', this.savedSearch.id ) < 0) {
                    this.savedSearch = null
                }

                if (this.initSavedSearch > 0) {
                    let groupIndex = this.arrayHelper.findIndexByColumnValueInGroup(this.savedSearches, 'items', 'id', this.initSavedSearch)

                    if (groupIndex >= 0) {
                        this.canLoadList = true
                        let itemIndex = this.arrayHelper.findIndexByColumnValue(this.savedSearches[groupIndex]['items'], 'id', this.initSavedSearch)
                        this.savedSearch = this.savedSearches[groupIndex]['items'][itemIndex]
                    }
                    else {
                        window.location.href = "/startups"
                    }
                }
            })
        },

        applySavedSearch() {
            let rules = JSON.parse(this.savedSearch.rules)
            this.notWatchFilters = true
            this.populateFilters(rules)

            this.$nextTick(() => {
                this.notWatchFilters = false
            })


            this.query.rules = rules
            this.getList()
            this.$nextTick(() => {
                this.savedSearchApplied = true
            })

            savedSearches.updateSearched(this.savedSearch.id)
        },

        populateFilters(rules) {

            rules.forEach(rule => {
                if (typeof rule.condition !== "undefined") {
                    this.populateFilters(rule.rules)
                }
                else {
                    if (rule.name != "Keyword") {
                        this.updateFilter(rule.name, rule.value)
                    }
                }
            })
        },

        clearFilters() {
            for (let key of Object.entries(this.filters)) {
                this.updateFilter(key[0], null)
            }
        },

        updateFilter(name, value) {
            this.notWatchFilters = true

            if (value == null) {
                if (Array.isArray(this.filters[name])) {
                    this.filters[name] = []
                }
                else {
                    if (name == 'name') {
                        this.filters[name] = null
                    }
                }
            }
            else {
                if (typeof this.filtersOptions[name] !== 'undefined') {
                    let values = []

                    this.filtersOptions[name].forEach(option => {
                        if (value.indexOf(option.value) >= 0) {
                            values.push(option)
                        }
                    })

                    this.filters[name] = values

                    if (name == 'locations') {
                        let missingLocations = []
                        value.forEach(item => {
                            if (this.arrayHelper.findIndexByColumnValue(this.filtersOptions[name], 'value', item) < 0) {
                                missingLocations.push(item)
                            }
                        })

                        if (missingLocations.length) {
                            locations.getLocationsList(missingLocations).then(response => {
                                response.data.forEach(item => {
                                    this.filtersOptions[name].push({
                                        name: item.name,
                                        value: item.value,
                                    })

                                    this.filters[name].push({
                                        name: item.name,
                                        value: item.value,
                                    })
                                })
                            })
                        }
                    }
                }
                else {
                    if (typeof this.showCalendar[name] !== 'undefined') {
                        this.showCalendar[name] = true
                        this.filters[name] = date.encodeInterval(value)
                    } else {
                        this.filters[name] = value
                    }
                }
            }
        },

        clearFilter(name) {
            if (name.search('custom') >= 0) {
                let parts = name.split('_')
                this.$refs.customDataFilter.removeFilterById(parts[1])
            }
            else {
                this.notWatchFilters = true

                if (Array.isArray(this.filters[name])) {
                    this.filters[name] = [];
                } else {
                    this.filters[name] = null;
                }

                this.$nextTick(() => {
                    this.notWatchFilters = false
                })
            }
        },

        clearAllFilters() {
            this.notWatchFilters = true
            for (let i in this.filters) {
                if (Array.isArray(this.filters[i])) {
                    this.filters[i] = []
                }
                else {
                    this.filters[i] = null
                }
            }

            this.$refs.customDataFilter.resetFilters()

            this.$nextTick(() => {
                this.notWatchFilters = false
            })
        },

        addKeyword() {
            this.currentKeyword = this.currentKeyword.trim();

            if (this.currentKeyword.length) {
                let keyWord = this.currentKeyword

                if (keyWord.indexOf(':') < 0) {
                    keyWord = this.stringHelper.sanitizeUrl(keyWord);
                }

                var rule =
                    {
                        "label"      : "Keyword",
                        "name"       : "keyword",
                        "value"      : keyWord,
                        "valueAlias" : keyWord,
                        "negative"   : false,
                        "groupWords"   : [],
                        "matchCount" : 1,
                    }

                this.prependRule(rule);
                this.currentKeyword = '';
                this.getList();

                if (typeof this.relatedWords[keyWord] == "undefined") {

                    axios.post("/search/get-related-words", {term: keyWord}).then(response => {
                        this.relatedWords[keyWord] = []

                        for (let i in response.data) {
                            let word = response.data[i]

                            if (this.relatedWords[keyWord].indexOf(word) < 0) {
                                this.relatedWords[keyWord].push(word)
                            }
                        }
                    })
                }
            }
        },

        keywordAutocompleteSubmitted(value) {
            this.currentKeyword = value
            this.addKeyword()
        },
        applySearchOperator(type, value) {
            if (!value.length) {
                value = (type == 'name') ? 'Name: ' : '"Your query"'
                this.$refs.keywordAutocompleter.setValue(value)
            } else {
                let prefix = (type == 'name') ? 'Name: ' : '"'
                let suffix = (type == 'exact-phrase') ? '' : '"'
                this.currentKeyword = prefix + value + suffix
                this.addKeyword()
                this.$refs.keywordAutocompleter.clear()
            }
        },
        openManageColumns() {
            this.$refs.manageColumns.open()
        },

        openCustomDataFilter() {
            this.$refs.customDataFilter.open()
        },

        openSaveSearch() {
            this.$refs.saveSearch.openSave()
        },

        updateSavedSearch() {
            this.$refs.saveSearch.updateQuery(this.savedSearch.id)
            this.canUpdateSavedSearch = false
        },

        savedSearchChanged() {
            this.getSavedSearches()
        },

        openManageSavedSearches() {
            this.$refs.saveSearch.openManage()
        },

        changeSelectedRows(ids) {
            this.selectedRows = ids
        },

        selectAllResults(result) {
            this.selectedAllResults = result
        },

        openAddTags() {
            this.$refs.addTags.open()
        },

        openRemoveTags() {
            this.$refs.removeTags.open()
        },

        openAddToTrackers() {
            this.$refs.addToTrackers.open()
        },
        //openExportContacts() {
        //this.$refs.exportContacts.open()
        //},

        addTags(addedTags) {
            let tagsIds = this.arrayHelper.arrayColumn(addedTags, 'value')
            if (this.selectedAllResults) {
                tags.addTagsByQuery(this.query, this.sort, tagsIds).then(() => {
                    this.$refs.addTags.close()
                })
            }
            else {
                let startups = this.selectedRows
                tags.addTags(startups, tagsIds).then(() => {
                    this.$refs.addTags.close()
                })
            }
        },

        removeTags(addedTags) {
            let tagsIds = this.arrayHelper.arrayColumn(addedTags, 'value')
            if (this.selectedAllResults) {
                tags.removeTagsByQuery(this.query, this.sort, tagsIds).then(() => {
                    this.$refs.removeTags.close()
                    this.getList()
                })
            }
            else {
                let startups = this.selectedRows
                tags.removeTags(startups, tagsIds).then(() => {
                    this.$refs.removeTags.close()
                    this.getList()
                })
            }
        },

        addToTrackers(addedTrackers) {
            let trackersIds = this.arrayHelper.arrayColumn(addedTrackers, 'value')
            if (this.selectedAllResults) {
                trackersStartups.addStartupsByQuery(this.query, this.sort, trackersIds).then(() => {
                    this.getList()
                })
            }
            else {
                let startups = this.selectedRows
                trackersStartups.addStartups(startups, trackersIds).then(() => {
                    this.getList()
                })
            }
        },

        exportCSV() {
            let result
            if (this.selectedAllResults) {
                result = exports.exportStartupsByQuery(this.searchType, this.query, this.sort, this.columns)
            }
            else {
                let startups = this.selectedRows
                result = exports.exportStartups(this.searchType, startups, this.columns)
            }

            result.then(response => {
                this.fileHelper.download(response.data, this.searchType + '.csv')
            })
        },

        editGroup(rule) {
            this.currentRule.id = rule.id
            this.currentRule.value = this.stringHelper.trimSymbol(rule.value, '"')
            this.currentRule.groupWords = rule.groupWords
            this.currentRule.matchCount = rule.matchCount

            this.$refs.manageGroupWords.open()
        },

        saveGroupWords(groupWords, matchCount) {
            this.updateRuleProps(this.currentRule, {groupWords: groupWords, matchCount: matchCount})
        },

        gridAction(params) {
            if (params.action == 'add-tracker') {
                this.addStartupToTracker = params.rowId
                this.$refs.editTracker.open(0)
            }
            else if (params.action == 'tag-clicked') {
                let tagIndex = this.arrayHelper.findIndexByColumnValue(this.filtersOptions['tags'], 'name', params.tagName)
                let existsIndex = this.arrayHelper.findIndexByColumnValue(this.filters.tags, 'name', params.tagName)

                if (tagIndex >= 0 && existsIndex < 0) {
                    this.filters.tags.push(this.filtersOptions['tags'][tagIndex])
                }
            }
            else if (params.action == 'invite-ecosystem') {
                this.$emit('invite', params.rowId)
            }
        },

        trackerSaved(trackerId) {
            this.getTrackersList()

            if (this.addStartupToTracker) {
                trackersStartups.addStartups([this.addStartupToTracker], [trackerId]).then(() => {

                    trackersStartups.getStartupTrackersCount(this.addStartupToTracker).then(response => {
                        let index = this.arrayHelper.findIndexByColumnValue(this.startups, "id", this.addStartupToTracker)
                        this.startups[index].name.trackersCount = response.data

                        this.addStartupToTracker = null
                    })
                })
            }
        },

        getColumns() {
            this.columns = []

            user.getColumns(this.tableColumnsType).then(response => {
                this.$refs.manageColumns.getColumns()

                let columns
                if (this.tableColumnsType == 'search-startups') {
                    columns = response.data.columns
                    this.includeHidden = response.data.params.include_hidden_startups
                }
                else {
                    columns = response.data
                }

                this.columns = []

                for (let i in columns) {
                    let column = columns[i]

                    if (columns[i].name == 'name') {
                        column.component = 'SearchCompanyNameColumn'
                    }

                    if (columns[i].name == 'location') {
                        column.component = 'SearchCompanyLocationColumn'
                    }

                    if (columns[i].name.indexOf('custom_') == 0 || columns[i].name.indexOf('diligence_') == 0) {
                        column.component = 'CustomField'
                    }

                    if (columns[i].name == 'ecosystems') {
                        column.component = 'RawColumn'
                    }

                    this.columns.push(column)
                }

                this.getList()
            })
        },
    },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>